export default __webpack_public_path__ + "static/media/987.28ecfee7.gif";